export default {
    removeUser(state) {
        state.user = {
            id: 0,
            mis_compras: [],
            mis_compras_regaladas: [],
            mis_compras_moviles: [],
            mis_compras_pendientes: [],
            mis_compras_app: [],
            mis_regalos: [],
            videos: []
        }
        state.site.didLoadUser = false
        state.site.didLoadUserVideos = false
    },
    setPortalReady(state, ready) {
        state.isPortalReady = ready
    },
    setPortalInfo(state, payload) {
        state.portal = {
            ...payload
        }
        state.isPortalReady = true
    },
    setUserCompras(state, payload) {
        state.user = Object.assign({}, state.user, payload)
        state.site.didLoadUserCompras = true
    },
    setUserInfo(state, payload) {
        // Siempre debe tener array de videos
        state.user = Object.assign({}, {
                videos: []
            },
            payload)
        state.site.didLoadUser = true
    },
    togglePortalLoginModal(state, toggle) {
        state.site.isPortalLoginModalVisible = toggle
    },
    togglePortalBarraPrecioFooterModal(state, toggle) {
        state.site.isBarraPrecioFooter = toggle
    },
    togglePortalRegistroModal(state, toggle) {
        state.site.isPortalRegistroModalVisible = toggle
    },
    setPasarelaPago(state, payload) {
        console.log(payload)
        state.site.setPasarelaPago = Object.assign({}, state.site.setPasarelaPago,
            payload
        )
    },
    updateUser(state, payload) {
        state.user = Object.assign({}, state.user,
            payload
        )
        state.site.didLoadUser = true
    },
    setCategoriaContenidos(state, payload) {
        state.portal.categorias.forEach(categoria => {
            if (categoria.id == payload.id_categoria) {
                categoria.contenidos = [...payload.contenidos]
                categoria.contenidosLoaded = true
            }
        })
    },
    setUserVideos(state, payload) {
        state.user.videos = [...payload.videos]
    },
    setIsLoadingPortal(state, toggle) {
        state.site.isLoadingPortal = toggle
    },
    setIsLoadingUser(state, toggle) {
        state.site.isLoadingUser = toggle
    },
    setIsLoadingUserVideos(state, toggle) {
        state.site.isLoadingUserVideos = toggle
    },
    setIsLoadingUserCompras(state, toggle) {
        state.site.isLoadingUserCompras = toggle
    },
    setDidLoadUserVideos(state, toggle) {
        state.site.setDidLoadUserVideos = toggle
    },
    setDidLoadUserCompras(state, toggle) {
        state.setDidLoadUserCompras = toggle
    },
    setIsLoadingCookie(state, toggle) {
        state.site.isLoadingCookie = toggle
    },
    setDidLoadUser(state, toggle) {
        state.site.didLoadUser = toggle
    },
    setIsSiteMenuVisible(state, toggle) {
        state.site.isSiteMenuVisible = toggle
    },
    toggleTransferenciaModalVisible(state, toggle) {
        state.site.isTransferenciaModalVisible = toggle
    },
    toggleCompletarPerfilModalVisible(state, toggle) {
        state.site.isCompletarPerfilModalVisible = toggle
    },
    updateSite(state, site) {
        state.site = {
            ...state.site,
            site
        }
    },

}
